export default (theme) => ({
  wrapper: {
    extend: theme.wrapper,
    display: 'flex',
    paddingTop: 200,
  },
  products: {
    marginTop: 150,
    // marginBottom: 150,
    width: '100%',
  },
  productView: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',
    marginLeft: -30,
    marginRight: -30,
    '& .productItem__root': {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 58,
      width: 'calc(100% / 4)',
      padding: '0 30px',
    },
    '& .productItem__image': {
      paddingBottom: '100%',
    },
    '& .productItem__desc': {
      paddingTop: 20,
    },
  },
  /*------------------------------
  LG
  ------------------------------*/
  [theme.mediaInverse.xl]: {
    productView: {
      flex: '1 1 100%',
      marginLeft: -20,
      marginRight: -20,
      '& .productItem__root': {
        width: 'calc(100% / 3)',
        padding: '0 20px',
      },
    },
  },
  [theme.mediaInverse.sm]: {
    wrapper: {
      paddingTop: 100,
    },

    products: {
      marginTop: 50,
    },
    productView: {
      marginLeft: -10,
      marginRight: -10,
      '& .productItem__root': {
        width: 'calc(100% / 2)',
        marginBottom: 25,
        padding: 10,
      },
    },
  },

  /*------------------------------
  XXS
  ------------------------------*/
  [theme.mediaInverse.xs]: {
    productView: {
      '& .productItem__cta': {
        display: 'none',
      },
      '& .productItem__title': {
        fontSize: 18,
      },
      '& .productItem__designer': {
        fontSize: 13,
      },
    },
  },
})
